import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';

export const toggleAllowOutlookTrackAdOption = action('lgpdOption_toggleAllowOutlookTrackAdOption');

export const loadLgpdOption = action('loadLgpdOption', () =>
    addDatapointConfig({ name: 'LoadLgpdOption' })
);

export const saveLgpdOption = action('saveLgpdOption', () =>
    addDatapointConfig({ name: 'SaveLgpdOption' })
);
